import Vue from 'vue'
import VueResource from 'vue-resource'
import QueryString from 'qs'
Vue.use(VueResource)

const API_URL = process.env.API_URL

export default {
  query (params) {
    return Vue.http.get(`${API_URL}yields`, {params: params})
  },
  get (id) {
    return Vue.http.get(`${API_URL}yields/${id}`)
  },
  create (data) {
    return Vue.http.post(`${API_URL}yields`, data)
  },
  update (id, data) {
    return Vue.http.patch(`${API_URL}yields/${id}`, data)
  },
  delete (id) {
    return Vue.http.delete(`${API_URL}yields/${id}`)
  },
  generateSheet (params) {
    return new Promise((resolve, reject) => {
      let url = `${API_URL}yields/sheet`
      if (params) {
        url = `${url}?${QueryString.stringify(params)}`
      }
      resolve(window.open(url, '_BLANK'))
    })
  },
  statusLabel: {
    provision: 'Provisão',
    paid: 'Pago'
  },
  statusClass: {
    provision: 'is-purple',
    paid: 'is-success'
  }
}



// WEBPACK FOOTER //
// ./src/services/yield.js